export const CN_MONTH_MAPPER = Object.freeze({
  "1月": 0,
  "2月": 1,
  "3月": 2,
  "4月": 3,
  "5月": 4,
  "6月": 5,
  "7月": 6,
  "8月": 7,
  "9月": 8,
  "10月": 9,
  "11月": 10,
  "12月": 11
});

export const CN_MONTH_LIST = [
  "1月",
  "2月",
  "3月",
  "4月",
  "5月",
  "6月",
  "7月",
  "8月",
  "9月",
  "10月",
  "11月",
  "12月"
];
